import React, { useState } from 'react';
import { Form, InputNumber, DatePicker, Input, Button, Row, Col, Tabs, message, Modal } from 'antd';
import axiosInstance from './axiosInstance';
import {formitems,handleException, getval} from './Utils.jsx'

let user = null;

function getUser() {return user}

function isAdmin() {
    return user?.rights.admin ?? false;
}

function hasRight(right,mode='') {
    const admin = user?.rights.admin ?? false;
    const rights = user?.rights ?? {};
    if(admin) return true
    switch(right) {
        case 'users': return rights.users ? mode <= rights.users : false;
        case 'loans': return rights.loans ? mode <= rights.loans : false;
        case 'assign_loan': return rights.assign_loan;
        case 'settings': return rights.settings;
        default: return false;
    } 
}

function getStorage(){
    return sessionStorage
}

async function logout(loggedout) {
    try {
        const token = getStorage().getItem('token');
        await axiosInstance.post('/logout', {}, {headers: {Authorization: `Bearer ${token}`}});
        getStorage().removeItem('token');
        user = null
        if(loggedout) loggedout()
        //history.push('/login');
    } catch (error) {
        console.error('Error logging out', error);
    }    
}



async function checkAuth() {
    try {
        const token = getStorage().getItem('token');
        if (!token) {
            console.warn('No token found');
            getStorage().removeItem('token');
            user = null;
        }
        else {
            const response = await axiosInstance.post('/check-auth', {}, {headers: {Authorization: `Bearer ${token}`}});
            if (response.status === 200) {
                user = response.data.user
            }
            else {    
                getStorage().removeItem('token');
                user = null
            }
        }    
        
    } catch (error) {
        getStorage().removeItem('token');
        user = null
        console.error('Error check_auth', error);
    }    
}

function FormLogin({register, logged}) {
    const [form] = Form.useForm();

    const items = [
        {name:"login",        label:"Uživatelské jméno",required:true,          ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"password",     label:"Heslo",required:true,                      ctrl: (pp)=>(<Input.Password {...pp}  />)}, 
    ]
    
    async function login() {	 
        try {
            const response = await axiosInstance.post('/login', {...form.getFieldsValue()});
            getStorage().setItem('token', response.data.access_token);
            user = response.data.user
            console.log(user, hasRight('icrecs'))
            
            if(logged) logged(user); 
        } catch (err) {
            console.log(err)
            message.error('Přihlášení se nezdařilo. ' + err?.response?.data?.message??''); 
        }
    }

    const formStyle = {
        width: '400px',
        margin: '0 auto',
        padding: '20px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        border: '1px solid #ccc',
        backgroundColor: '#fff'
    }

    return (
        <div>
        <Form
            form={form}
            name={'loginForm'}
            labelCol={{ span: 10 }}
            onFinish={()=>login()}
            style = {formStyle}
        >           
            {formitems(items,{},{},1)} 
            
            <Form.Item wrapperCol={{ offset: 8, span: 24 }}>
                <Button type="primary" htmlType="submit">Přihlásit</Button>
                <Button onClick={register} style={{ marginLeft: '10px' }}>Registrovat</Button>
            </Form.Item>
        </Form>
        </div>
    )
}  

function FormRegister({registered}) {
    const [form] = Form.useForm();
 
    const validatePassword = (_, value) => {
        if (!value) return Promise.reject(new Error('Heslo je požadováno'));
        if (value.length < 8) return Promise.reject(new Error('Heslo musí mít aspoň 8 znaků'));
        //if (!/[A-Z]/.test(value)) return Promise.reject(new Error('Password must contain at least one uppercase letter'));
        //if (!/[0-9]/.test(value)) return Promise.reject(new Error('Password must contain at least one number'));
        if (!/[^A-Za-z0-9]/.test(value)) return Promise.reject(new Error('Password must contain at least one special character'));
        return Promise.resolve();
    };
    const comparePassword = (_, value) => {
        if (value != form.getFieldValue('password1')) return Promise.reject(new Error('Zadaná hesla nejsou stejná'));
        return Promise.resolve();
    };

    const items = [
        {name:"login",        label:"Uživatelské jméno",required:true,                                  ctrl: (pp)=>(<Input {...pp}  />)},
        {name:"password1",    label:"Heslo",required:true,rules:[{ validator: validatePassword }],      ctrl: (pp)=>(<Input.Password {...pp}  />)},
        {name:"password2",    label:"Heslo znovu",required:true,rules:[{ validator: comparePassword }], ctrl: (pp)=>(<Input.Password {...pp}  />)},  
    ]
    
    async function register() {	
        try {
            const response = await axiosInstance.post('/register', {...form.getFieldsValue()});
            if(registered) registered();
            message.success('Uživatel byl úspěšně registrován');
        } catch (err) {
            console.log(err)
            handleException(err)
            //message.error('Registrace se nezdařila'); 
        };
    }

    function handleChange(changedValues, allValues) { 
        //console.log('allvalues',allValues)
        //console.log('changedvalues',changedValues)
        if(changedValues.password1) form.setFieldValue('password2',null)          
    };

    const formStyle = {
        width: '400px',
        margin: '0 auto',
        padding: '20px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        border: '1px solid #ccc',
        backgroundColor: '#fff'
    }

    return (
        <div>
        <Form
            form={form}
            name={'registerForm'}
            labelCol={{ span: 10 }}
            onFinish={()=>register()}
            onValuesChange={handleChange}
            style = {formStyle}
        >           
            {formitems(items,{},{},1)} 
            
            <Form.Item wrapperCol={{ offset: 8, span: 24 }}>
                <Button type="primary" htmlType="submit">Registrovat</Button>
            </Form.Item>
        </Form>
        </div>
    )
}

function LoginRegister({logged}){
    const [state,setState] = useState('login')
    return (
        <div>
        {
            state=='login' ? 
            <FormLogin register={()=>{setState('register')}} logged={logged}/> 
            : 
            <FormRegister registered={()=>{setState('login')}}/>
        }
        </div>
    )
}



export {LoginRegister, logout, getUser, hasRight, checkAuth, isAdmin}